export const FEATURE_RESEARCH_EN = {
  featureResearch: {
    periods: {
      selectPeriod: 'Select period',
      period: 'Period',
      overall: 'All Time',
      monthly: 'This Month',
      weekly: 'This Week',
      today: 'Today',
      last30Days: 'Last 30 Days'
    },
    common: {
      refresh: 'Refresh',
      noDataAvailable: 'No data available',
      noDataForPeriod: 'No data available for this period',
      tokens: 'Tokens',
      tokenBreakdown: 'Token Breakdown',
      inputTokens: 'Input Tokens',
      outputTokens: 'Output Tokens',
      reasoningTokens: 'Reasoning Tokens',
      content: 'Content',
      cost: 'Cost',
      none: 'None',
      notAvailable: 'N/A',
      noOrg: 'No org',
      pieceSuffix: '/piece'
    },
    adminStatistics: {
      title: 'Statistics Dashboard',
      description: 'Monitor performance and usage metrics',
      totalUsers: 'Total Users',
      organizations: 'Organizations',
      activeUsers: 'Active Users',
      activeOrgs: 'Active Orgs',
      tokensUsed: 'Tokens Used',
      contentGenerated: 'Content Generated',
      totalCost: 'Total Cost',
      cost: 'Cost',
      activeCount: '{count} active',
      topOrganizations: 'Top Organizations',
      topUsers: 'Top Users',
      detailedBreakdown: 'Detailed Breakdown',
      byTokenUsage: 'By Token Usage',
      byContentGenerated: 'By Content Generated',
      byCost: 'By Cost',
      organisationDeepDive: 'Organisation Deep Dive',
      selectOrganisationToView: 'Select an organisation to view detailed user statistics',
      organizationTab: 'Organizations',
      usersTab: 'Users',
      promptsTab: 'Prompts',
      tokenCount: '{count} tokens'
    },
    topMetricsCard: {
      name: 'Name',
      noDataAvailable: 'No data available',
      seeMore: 'See {count} more',
      showLess: 'Show less'
    },
    tokenUsageDistribution: {
      title: 'Token Usage Distribution',
      loadingDistribution: 'Loading distribution...',
      noTokenUsageData: 'No token usage data available',
      others: 'Others'
    },
    usageTimeSeries: {
      title: 'Usage Over Time',
      avgDailyContent: 'Avg Daily Content',
      noUsageDataForPeriod: 'No usage data available for this period'
    },
    organisationUserStatistics: {
      title: 'User Statistics',
      weekly: 'Weekly',
      monthly: 'Monthly',
      overall: 'Overall',
      totalTokens: 'Total Tokens',
      contentCreated: 'Content Created',
      avgEfficiency: 'Avg Efficiency',
      user: 'User',
      tokens: 'Tokens',
      content: 'Content',
      efficiency: 'Efficiency',
      noUserActivityForPeriod: 'No user activity for this period',
      activityTooltip: 'Activity: {level}'
    },
    organisationSelector: {
      selectOrganisation: 'Select an organisation',
      searchOrganisations: 'Search organisations...',
      noOrganisationsFound: 'No organisations found'
    },
    researchChatStatistics: {
      title: 'Research Chat Analytics',
      description: 'View research chat usage statistics and trends',
      totalSessions: 'Total Sessions',
      totalMessages: 'Total Messages',
      totalTokens: 'Total Tokens',
      errorRate: 'Error Rate',
      avgCostPerSession: 'Avg Cost/Session',
      loadingStatistics: 'Loading statistics...',
      modelUsage: 'Model Usage ({period})',
      model: 'Model',
      sessions: 'Sessions',
      messages: 'Messages',
      tokens: 'Tokens',
      cost: 'Cost',
      tokenBreakdown: 'Token Breakdown',
      inputTokens: 'Input Tokens',
      outputTokens: 'Output Tokens',
      reasoningTokens: 'Reasoning Tokens',
      sessionMetrics: 'Session Metrics',
      finishedSessions: 'Finished Sessions',
      totalErrors: 'Total Errors',
      fetchFailed: 'Failed to fetch statistics: {error}'
    },
    researchChat: {
      chatLibrary: 'Chat Library',
      searchSessions: 'Search sessions...',
      clearSearch: 'Clear search',
      noSessionsFound: 'No sessions found',
      closeSessions: 'Close sessions',
      showSessions: 'Show sessions',
      welcomeTitle: 'Welcome to Research Chat',
      welcomeDescription:
        'Ask questions and get AI-powered research with cited sources. Start a conversation to begin.',
      startConversation: 'Start a conversation',
      startConversationDescription: 'Ask questions and get AI-powered research with cited sources',
      composerPlaceholder: 'Ask a research question...',
      sourcesCount: '{count} Sources',
      sendToEditor: 'Send to Editor',
      retry: 'Retry',
      like: 'Like',
      dislike: 'Dislike',
      sessionTitle: 'Research Chat',
      sessionPreviewFallback: 'New chat',
      justNow: 'Just now',
      minutesAgo: '{count}m ago',
      hoursAgo: '{count}h ago',
      daysAgo: '{count}d ago',
      quickPanelTitleSr: 'Chat quick panel',
      quickPanelDescriptionSr: 'Contextual chat research panel.',
      quickPanelAriaLabel: 'Chat quick panel',
      quickPanelSubtitle: 'Research chat while staying on this page.',
      openFullScreen: 'Open full screen',
      quickPanelEmptyHint: 'Ask a research question and stay in your current workflow.'
    },
    assistant: {
      inputPlaceholderResearch: 'Ask a research question...',
      inputPlaceholderHelp: 'Ask for help...',
      emptyTitleResearch: 'Start researching',
      emptyDescriptionResearch: 'Ask questions and get AI-powered research with cited sources.',
      sessionTitleResearch: 'Chat Research',
      emptyTitleHelp: 'How can I help?',
      emptyDescriptionHelp: 'Ask for contextual guidance while you work.',
      sessionTitleHelp: 'Chat Help',
      newChatFallback: 'New chat',
      justNow: 'Just now',
      minutesAgo: '{count}m ago',
      hoursAgo: '{count}h ago',
      daysAgo: '{count}d ago',
      startNewChatForSession: 'Start new chat ({session})'
    },
    tprompts: {
      featureKeyRequiredBeforeActivation: 'Feature key is required before activation.',
      activationSuccess: 'TPrompt activated successfully.',
      activationFailed: 'Failed to activate TPrompt.',
      deactivationSuccess: 'TPrompt deactivated successfully.',
      deactivationFailed: 'Failed to deactivate TPrompt.'
    },
    modelManagement: {
      tpromptUuidMissing: 'TPrompt UUID is missing.',
      activationFailedWithError: 'Failed to activate TPrompt: {error}'
    },
    modelCatalog: {
      title: 'Model Catalog',
      description:
        'View discovered provider models from GET /api/model and trigger refresh via POST /api/model/discovery/refresh',
      searchPlaceholder: 'Search provider, model, category...',
      provider: 'Provider',
      allProviders: 'All Providers',
      state: 'State',
      allStates: 'All States',
      active: 'Active',
      inactive: 'Inactive',
      clear: 'Clear',
      runDiscovery: 'Run discovery',
      refresh: 'Refresh',
      showingSummary: 'Showing {filtered} of {total} models',
      loadingCatalog: 'Loading model catalog...',
      modelName: 'Model Name',
      category: 'Category',
      scope: 'Scope',
      status: 'Status',
      pricing: 'Pricing',
      configured: 'Configured',
      unconfigured: 'Unconfigured',
      capabilities: 'Capabilities',
      lastError: 'Last Error',
      noScope: 'No scope',
      noModelsFound: 'No models found in catalog',
      clearFilters: 'Clear filters',
      unknown: 'unknown',
      none: 'None',
      notAvailable: 'N/A',
      statusUnknown: 'UNKNOWN',
      lastCheck: 'Last check',
      lastErrorLabel: 'Last error',
      discoveryRefreshSummary: 'Discovery refresh completed: {summary}',
      discoveryRefreshFailed: 'Model discovery refresh failed.',
      fetchFailed: 'Failed to fetch model catalog.',
      runDiscoveryFailed: 'Failed to run model discovery refresh.',
      summaryUpdated: 'updated {count}',
      summarySkipped: 'skipped {count}',
      summaryActive: 'active {count}',
      summaryDown: 'down {count}',
      summaryUnconfigured: 'unconfigured {count}',
      summaryProviders: 'providers {providers}'
    },
    modelCatalogDetails: {
      title: 'Model Catalog Entry',
      description: 'Edit scope and pricing assignment for this model.',
      saveScope: 'Save Scope',
      saveSettings: 'Save Settings',
      unnamedModel: 'Unnamed model',
      provider: 'Provider',
      modelName: 'Model Name',
      category: 'Category',
      uuid: 'UUID',
      capabilities: 'Capabilities',
      scope: 'Scope',
      pricingState: 'Pricing State',
      pricingSection: 'Pricing (USD)',
      pricingPlaceholder: 'Leave empty to unset',
      pricingInputPrice: 'Input Price per 1M Tokens',
      pricingOutputPrice: 'Output Price per 1M Tokens',
      pricingReasoningPrice: 'Reasoning Price per 1M Tokens',
      pricingCacheReadPrice: 'Cache Read Price per 1M Tokens',
      pricingCacheWritePrice: 'Cache Write Price per 1M Tokens',
      pricingAudioPrice: 'Audio Price per Minute',
      pricingOcrPrice: 'OCR Price per 1000 Pages',
      pricingWebSearchPrice: 'Web Search Price per 1K Requests',
      pricingImageGenerationPrice: 'Image Generation Price per 1K Images',
      selectScope: 'Select scope',
      unnamedScope: 'Unnamed Scope',
      loadingModelDetails: 'Loading model details...',
      modelNotFound: 'Model not found.',
      modelNameMissing: 'Model name is missing. Cannot update scope.',
      pleaseSelectScope: 'Please select a scope.',
      modelScopeUpdated: 'Model scope updated.',
      modelSettingsUpdated: 'Model settings updated.',
      invalidPricingValue: 'Invalid pricing value for {field}. Use a non-negative number.',
      failedLoadModelDetails: 'Failed to load model details: {error}',
      failedUpdateModelScope: 'Failed to update model scope: {error}',
      failedUpdateModelSettings: 'Failed to update model settings: {error}'
    },
    imageStudio: {
      preset: 'Preset',
      defaultPreset: 'Default'
    }
  }
}

export const FEATURE_RESEARCH_DE = {
  featureResearch: {
    periods: {
      selectPeriod: 'Zeitraum auswählen',
      period: 'Zeitraum',
      overall: 'Gesamtzeit',
      monthly: 'Dieser Monat',
      weekly: 'Diese Woche',
      today: 'Heute',
      last30Days: 'Letzte 30 Tage'
    },
    common: {
      refresh: 'Aktualisieren',
      noDataAvailable: 'Keine Daten verfügbar',
      noDataForPeriod: 'Keine Daten für diesen Zeitraum verfügbar',
      tokens: 'Tokens',
      tokenBreakdown: 'Token-Aufteilung',
      inputTokens: 'Eingabe-Tokens',
      outputTokens: 'Ausgabe-Tokens',
      reasoningTokens: 'Reasoning-Tokens',
      content: 'Inhalt',
      cost: 'Kosten',
      none: 'Keine',
      notAvailable: 'k.A.',
      noOrg: 'Keine Organisation',
      pieceSuffix: '/Stück'
    },
    adminStatistics: {
      title: 'Statistik-Dashboard',
      description: 'Leistung und Nutzungskennzahlen überwachen',
      totalUsers: 'Nutzer gesamt',
      organizations: 'Organisationen',
      activeUsers: 'Aktive Nutzer',
      activeOrgs: 'Aktive Organisationen',
      tokensUsed: 'Verbrauchte Tokens',
      contentGenerated: 'Erstellte Inhalte',
      totalCost: 'Gesamtkosten',
      cost: 'Kosten',
      activeCount: '{count} aktiv',
      topOrganizations: 'Top-Organisationen',
      topUsers: 'Top-Nutzer',
      detailedBreakdown: 'Detaillierte Aufschlüsselung',
      byTokenUsage: 'Nach Token-Verbrauch',
      byContentGenerated: 'Nach erstellten Inhalten',
      byCost: 'Nach Kosten',
      organisationDeepDive: 'Organisation im Detail',
      selectOrganisationToView:
        'Wählen Sie eine Organisation aus, um detaillierte Nutzerstatistiken zu sehen',
      organizationTab: 'Organisationen',
      usersTab: 'Nutzer',
      promptsTab: 'Prompts',
      tokenCount: '{count} Tokens'
    },
    topMetricsCard: {
      name: 'Name',
      noDataAvailable: 'Keine Daten verfügbar',
      seeMore: '{count} weitere anzeigen',
      showLess: 'Weniger anzeigen'
    },
    tokenUsageDistribution: {
      title: 'Token-Verteilung',
      loadingDistribution: 'Verteilung wird geladen...',
      noTokenUsageData: 'Keine Token-Nutzungsdaten verfügbar',
      others: 'Sonstige'
    },
    usageTimeSeries: {
      title: 'Nutzung über die Zeit',
      avgDailyContent: 'Durchschnittlicher Inhalt pro Tag',
      noUsageDataForPeriod: 'Keine Nutzungsdaten für diesen Zeitraum verfügbar'
    },
    organisationUserStatistics: {
      title: 'Nutzerstatistiken',
      weekly: 'Wöchentlich',
      monthly: 'Monatlich',
      overall: 'Gesamt',
      totalTokens: 'Tokens gesamt',
      contentCreated: 'Erstellter Inhalt',
      avgEfficiency: 'Durchschnittliche Effizienz',
      user: 'Nutzer',
      tokens: 'Tokens',
      content: 'Inhalt',
      efficiency: 'Effizienz',
      noUserActivityForPeriod: 'Keine Nutzeraktivität für diesen Zeitraum',
      activityTooltip: 'Aktivität: {level}'
    },
    organisationSelector: {
      selectOrganisation: 'Organisation auswählen',
      searchOrganisations: 'Organisationen durchsuchen...',
      noOrganisationsFound: 'Keine Organisationen gefunden'
    },
    researchChatStatistics: {
      title: 'Research-Chat-Analysen',
      description: 'Nutzungsstatistiken und Trends des Research-Chats ansehen',
      totalSessions: 'Sitzungen gesamt',
      totalMessages: 'Nachrichten gesamt',
      totalTokens: 'Tokens gesamt',
      errorRate: 'Fehlerrate',
      avgCostPerSession: 'Durchschn. Kosten/Sitzung',
      loadingStatistics: 'Statistiken werden geladen...',
      modelUsage: 'Modellnutzung ({period})',
      model: 'Modell',
      sessions: 'Sitzungen',
      messages: 'Nachrichten',
      tokens: 'Tokens',
      cost: 'Kosten',
      tokenBreakdown: 'Token-Aufteilung',
      inputTokens: 'Eingabe-Tokens',
      outputTokens: 'Ausgabe-Tokens',
      reasoningTokens: 'Reasoning-Tokens',
      sessionMetrics: 'Sitzungskennzahlen',
      finishedSessions: 'Abgeschlossene Sitzungen',
      totalErrors: 'Fehler gesamt',
      fetchFailed: 'Statistiken konnten nicht geladen werden: {error}'
    },
    researchChat: {
      chatLibrary: 'Chat-Bibliothek',
      searchSessions: 'Sitzungen durchsuchen...',
      clearSearch: 'Suche löschen',
      noSessionsFound: 'Keine Sitzungen gefunden',
      closeSessions: 'Sitzungen ausblenden',
      showSessions: 'Sitzungen anzeigen',
      welcomeTitle: 'Willkommen im Research-Chat',
      welcomeDescription:
        'Stellen Sie Fragen und erhalten Sie KI-gestützte Recherche mit Quellenangaben. Starten Sie eine Unterhaltung, um zu beginnen.',
      startConversation: 'Starten Sie eine Unterhaltung',
      startConversationDescription:
        'Stellen Sie Fragen und erhalten Sie KI-gestützte Recherche mit Quellenangaben',
      composerPlaceholder: 'Stellen Sie eine Recherchefrage...',
      sourcesCount: '{count} Quellen',
      sendToEditor: 'An Editor senden',
      retry: 'Erneut versuchen',
      like: 'Hilfreich',
      dislike: 'Nicht hilfreich',
      sessionTitle: 'Recherche-Chat',
      sessionPreviewFallback: 'Neuer Chat',
      justNow: 'Gerade eben',
      minutesAgo: 'vor {count} Min.',
      hoursAgo: 'vor {count} Std.',
      daysAgo: 'vor {count} T.',
      quickPanelTitleSr: 'Chat-Schnellpanel',
      quickPanelDescriptionSr: 'Kontextbezogenes Research-Chat-Panel des Chats.',
      quickPanelAriaLabel: 'Chat-Schnellpanel',
      quickPanelSubtitle: 'Recherche-Chat, ohne diese Seite zu verlassen.',
      openFullScreen: 'Vollbild öffnen',
      quickPanelEmptyHint:
        'Stellen Sie eine Recherchefrage und bleiben Sie in Ihrem aktuellen Workflow.'
    },
    assistant: {
      inputPlaceholderResearch: 'Stellen Sie eine Recherchefrage...',
      inputPlaceholderHelp: 'Wobei kann ich helfen?',
      emptyTitleResearch: 'Recherche starten',
      emptyDescriptionResearch:
        'Stellen Sie Fragen und erhalten Sie KI-gestützte Recherche mit Quellenangaben.',
      sessionTitleResearch: 'Recherche-Chat',
      emptyTitleHelp: 'Wie kann ich helfen?',
      emptyDescriptionHelp: 'Fragen Sie nach kontextbezogener Hilfe während der Arbeit.',
      sessionTitleHelp: 'Chat Hilfe',
      newChatFallback: 'Neuer Chat',
      justNow: 'Gerade eben',
      minutesAgo: 'vor {count} Min.',
      hoursAgo: 'vor {count} Std.',
      daysAgo: 'vor {count} T.',
      startNewChatForSession: 'Neuen Chat starten ({session})'
    },
    tprompts: {
      featureKeyRequiredBeforeActivation: 'Feature-Key ist vor der Aktivierung erforderlich.',
      activationSuccess: 'TPrompt erfolgreich aktiviert.',
      activationFailed: 'TPrompt konnte nicht aktiviert werden.',
      deactivationSuccess: 'TPrompt erfolgreich deaktiviert.',
      deactivationFailed: 'TPrompt konnte nicht deaktiviert werden.'
    },
    modelManagement: {
      tpromptUuidMissing: 'TPrompt-UUID fehlt.',
      activationFailedWithError: 'TPrompt konnte nicht aktiviert werden: {error}'
    },
    modelCatalog: {
      title: 'Modellkatalog',
      description:
        'Anbietermodelle aus GET /api/model ansehen und Aktualisierung über POST /api/model/discovery/refresh auslösen',
      searchPlaceholder: 'Anbieter, Modell, Kategorie suchen...',
      provider: 'Anbieter',
      allProviders: 'Alle Anbieter',
      state: 'Status',
      allStates: 'Alle Status',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      clear: 'Zurücksetzen',
      runDiscovery: 'Discovery ausführen',
      refresh: 'Aktualisieren',
      showingSummary: '{filtered} von {total} Modellen angezeigt',
      loadingCatalog: 'Modellkatalog wird geladen...',
      modelName: 'Modellname',
      category: 'Kategorie',
      scope: 'Scope',
      status: 'Status',
      pricing: 'Pricing',
      configured: 'Konfiguriert',
      unconfigured: 'Nicht konfiguriert',
      capabilities: 'Fähigkeiten',
      lastError: 'Letzter Fehler',
      noScope: 'Kein Scope',
      noModelsFound: 'Keine Modelle im Katalog gefunden',
      clearFilters: 'Filter zurücksetzen',
      unknown: 'unbekannt',
      none: 'Keine',
      notAvailable: 'k.A.',
      statusUnknown: 'UNBEKANNT',
      lastCheck: 'Letzter Check',
      lastErrorLabel: 'Letzter Fehler',
      discoveryRefreshSummary: 'Discovery-Aktualisierung abgeschlossen: {summary}',
      discoveryRefreshFailed: 'Model-Discovery-Aktualisierung fehlgeschlagen.',
      fetchFailed: 'Modellkatalog konnte nicht geladen werden.',
      runDiscoveryFailed: 'Model-Discovery konnte nicht ausgeführt werden.',
      summaryUpdated: 'aktualisiert {count}',
      summarySkipped: 'übersprungen {count}',
      summaryActive: 'aktiv {count}',
      summaryDown: 'nicht verfügbar {count}',
      summaryUnconfigured: 'nicht konfiguriert {count}',
      summaryProviders: 'anbieter {providers}'
    },
    modelCatalogDetails: {
      title: 'Modellkatalog-Eintrag',
      description: 'Scope- und Preis-Zuweisung für dieses Modell bearbeiten.',
      saveScope: 'Scope speichern',
      saveSettings: 'Einstellungen speichern',
      unnamedModel: 'Unbenanntes Modell',
      provider: 'Anbieter',
      modelName: 'Modellname',
      category: 'Kategorie',
      uuid: 'UUID',
      capabilities: 'Fähigkeiten',
      scope: 'Scope',
      pricingState: 'Preisstatus',
      pricingSection: 'Preise (USD)',
      pricingPlaceholder: 'Leer lassen zum Zurücksetzen',
      pricingInputPrice: 'Eingabe-Preis pro 1M Tokens',
      pricingOutputPrice: 'Ausgabe-Preis pro 1M Tokens',
      pricingReasoningPrice: 'Reasoning-Preis pro 1M Tokens',
      pricingCacheReadPrice: 'Cache-Read-Preis pro 1M Tokens',
      pricingCacheWritePrice: 'Cache-Write-Preis pro 1M Tokens',
      pricingAudioPrice: 'Audio-Preis pro Minute',
      pricingOcrPrice: 'OCR-Preis pro 1000 Seiten',
      pricingWebSearchPrice: 'Web-Search-Preis pro 1K Requests',
      pricingImageGenerationPrice: 'Bildgenerierungspreis pro 1K Bilder',
      selectScope: 'Scope auswählen',
      unnamedScope: 'Unbenannter Scope',
      loadingModelDetails: 'Modelldetails werden geladen...',
      modelNotFound: 'Modell nicht gefunden.',
      modelNameMissing: 'Modellname fehlt. Scope kann nicht aktualisiert werden.',
      pleaseSelectScope: 'Bitte einen Scope auswählen.',
      modelScopeUpdated: 'Modell-Scope aktualisiert.',
      modelSettingsUpdated: 'Modelleinstellungen aktualisiert.',
      invalidPricingValue:
        'Ungültiger Preiswert für {field}. Bitte eine nicht-negative Zahl verwenden.',
      failedLoadModelDetails: 'Modelldetails konnten nicht geladen werden: {error}',
      failedUpdateModelScope: 'Modell-Scope konnte nicht aktualisiert werden: {error}',
      failedUpdateModelSettings: 'Modelleinstellungen konnten nicht aktualisiert werden: {error}'
    },
    imageStudio: {
      preset: 'Voreinstellung',
      defaultPreset: 'Standard'
    }
  }
}
